export default __webpack_public_path__ + "static/PromptIconSix-7a08c1b0f011e830b174c329aa74bdcc.png";